import React, {useState} from "react";
import clsx from "clsx";
import {useResortsMenu} from "../../../hooks";
import {useI18N} from "../../../common/common";
import ArrowDown from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/arrows-diagrams/arrows/arrow-down-1.svg";
import ArrowUp from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/arrows-diagrams/arrows/arrow-up-1.svg";
import {StreamlineIcon} from "@hapinest/theme";
import {
    List,
    ListItem,
    ListItemText,
    Collapse,
    Box,
    Typography,
    makeStyles
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    countryIcon: {
        width: theme.spacing(2),
        height: theme.spacing(2),
        marginRight: theme.spacing(2),
        display: "flex"
    },
    listItem: {
        minHeight: theme.spacing(6),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
    },
    countryListItem: {
        minHeight: theme.spacing(6),
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(3)
    },
    destListItem: {
        minHeight: theme.spacing(6),
        paddingLeft: theme.spacing(9),
        paddingRight: theme.spacing(3)
    },
    selected: {
        backgroundColor: `${theme.palette.secondary[100]} !important`
    }
}));

const HeaderProfileMenuResortList = () => {
    const classes = useStyles();
    const {menuItems} = useResortsMenu(classes.countryIcon);
    const {i18n} = useI18N();

    const [open, setOpen] = useState(false);
    const [countryOpen, setCountryOpen] = useState();

    const handleMainClick = () => {
        if (open) {
            setCountryOpen();
        }
        setOpen(!open);
    };

    const handleCountryItemClick = (index) => {
        if (index === countryOpen) {
            setCountryOpen();
        } else {
            setCountryOpen(index);
        }
    };

    return (
        <>
            <ListItem
                onClick={handleMainClick}
                button
                className={clsx(classes.listItem, { [classes.selected]: open && !countryOpen })}
            >
                <ListItemText primary={i18n("common.label.resorts")} />
                <StreamlineIcon size={20}>
                    {open ? <ArrowUp /> : <ArrowDown />}
                </StreamlineIcon>
            </ListItem>
            <Collapse
                in={open}
                timeout={"auto"}
                unmountOnExit
            >
                <List>
                    {menuItems?.map((item, index) => (
                        <Box key={index}>
                            <ListItem
                                key={index}
                                className={clsx(classes.countryListItem, {
                                    [classes.selected]: countryOpen === index
                                })}
                                button
                                onClick={() => handleCountryItemClick(index)}
                                component={"a"}
                                href={!item?.subItems?.length ? item?.href : undefined}
                            >
                                {item?.icon}

                                <ListItemText>
                                    <Typography variant="body2">
                                        {item?.text}
                                    </Typography>
                                </ListItemText>

                                {item?.subItems?.length > 0 &&
                                    <StreamlineIcon size={20}>
                                        {countryOpen === index ? <ArrowUp /> : <ArrowDown />}
                                    </StreamlineIcon>
                                }
                            </ListItem>
                            {item?.subItems?.length > 0 &&
                                <Collapse in={countryOpen === index}>
                                    {item.subItems.length > 1 && item.href &&
                                        <ListItem
                                            key={index}
                                            className={classes.destListItem}
                                            button
                                            component={"a"}
                                            href={item?.href}
                                        >
                                            <ListItemText>
                                                <Typography variant="body2">
                                                    {item?.isPartnerResortsList ? i18n("view.booking_information.all_partner_resorts") : i18n("view.resorts_menu.all_resorts_in_country", {country: item?.text})}
                                                </Typography>
                                            </ListItemText>
                                        </ListItem>
                                    }
                                    {item?.subItems?.map((item, index) => (
                                        <ListItem
                                            key={index}
                                            className={classes.destListItem}
                                            button
                                            component={"a"}
                                            href={item?.href}
                                        >
                                            <ListItemText>
                                                <Typography variant="body2">
                                                    {item?.text}
                                                </Typography>
                                            </ListItemText>
                                        </ListItem>
                                    ))}
                                </Collapse>
                            }
                        </Box>
                    ))}
                </List>
            </Collapse>
        </>
    );
};

export default HeaderProfileMenuResortList;
